module.exports = __webpack_public_path__ + "static/media/eie.828b17cb.m4a";